import { router, usePage } from "@inertiajs/react"
import { Eye, X } from "lucide-react"
import { Button } from "@/components/ui/button"

// U7 — the "view as member" preview affordance, rendered at the top of every
// member-portal page. Three states, driven by shared props:
//   - viewingAsMember: a signposted banner + "Exit preview" + back-to-coach link
//   - canPreviewAsMember (coach of the active group, not previewing): an
//     unobtrusive "View as member" button
//   - otherwise: nothing
export function ViewAsMemberBanner() {
  const { props } = usePage()
  const { viewingAsMember, canPreviewAsMember } = props

  if (viewingAsMember) {
    return (
      <div className="mb-4 flex flex-col gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2 text-sm">
          <Eye className="h-4 w-4 shrink-0" aria-hidden />
          <span>
            <span className="font-medium">Viewing as your members see it.</span>{" "}
            Coach-only content is hidden — manage it from the Coach Portal.
          </span>
        </div>
        <div className="flex shrink-0 items-center gap-3">
          <a
            href="/app/coach"
            className="text-sm font-medium underline underline-offset-2 hover:text-amber-950"
          >
            Coach Portal
          </a>
          <Button
            size="sm"
            variant="outline"
            className="border-amber-300 bg-white hover:bg-amber-100"
            onClick={() => router.delete("/app/member/view_as_member", { preserveScroll: true })}
          >
            <X className="mr-1 h-4 w-4" aria-hidden />
            Exit preview
          </Button>
        </div>
      </div>
    )
  }

  if (canPreviewAsMember) {
    return (
      <div className="mb-4 flex items-center justify-end">
        <Button
          size="sm"
          variant="outline"
          onClick={() => router.patch("/app/member/view_as_member", {}, { preserveScroll: true })}
        >
          <Eye className="mr-1 h-4 w-4" aria-hidden />
          View as member
        </Button>
      </div>
    )
  }

  return null
}
